import { createStandaloneToast, theme } from "@chakra-ui/react";

export const { toast } = createStandaloneToast({ theme });
